export { renderMenuItemSwitch_unstable as renderMenuItemSwitch } from '@fluentui/react-menu';
